import { useLocalStorage } from 'usehooks-ts'

import type { SortDir } from '@fv/models'

export const PENDING_LOCAL_STORAGE_SORTDIR_KEY = 'pending-list-sort-direction'
export const CONFIRMED_LOCAL_STORAGE_SORTDIR_KEY =
  'confirmed-list-sort-direction'

export const useSortDirectionPreference = (key: string) => {
  return useLocalStorage<SortDir | undefined>(key, undefined)
}

export const usePendingSortDirectionPreference = () => {
  return useSortDirectionPreference(PENDING_LOCAL_STORAGE_SORTDIR_KEY)
}
export const useConfirmedSortDirectionPreference = () => {
  return useSortDirectionPreference(CONFIRMED_LOCAL_STORAGE_SORTDIR_KEY)
}
